// Leitura das respostas da API de pedidos de compra — puro, sem rede, para ser testável
// (mesmo espírito de deliveryDraftStore.ts).

import { PurchaseOrder, PurchaseOrderStatusSummary } from '../types/purchaseOrder';

interface RawPagination {
  page?: number;
  page_size?: number;
  total_items?: number;
  total_pages?: number;
}

export interface RawPurchaseOrderListJson {
  data?: PurchaseOrder[] | { data?: PurchaseOrder[]; pagination?: RawPagination } | null;
  pagination?: RawPagination | null;
  summary?: PurchaseOrderStatusSummary | null;
}

export interface PurchaseOrderListPage {
  data: PurchaseOrder[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
  /** Contadores por situação da listagem inteira; ausente se a API não conseguiu calcular. */
  summary?: PurchaseOrderStatusSummary;
}

/**
 * A API responde { success, data, pagination, summary } com a paginação em snake_case NA RAIZ.
 * Ler `data.pagination`, como era antes, fazia total_pages cair no default 1: a tela escondia a
 * paginação e só mostrava os 20 primeiros pedidos. O formato aninhado fica como fallback.
 */
export function readPurchaseOrderListPage(
  json: RawPurchaseOrderListJson,
  page: number,
  pageSize: number,
): PurchaseOrderListPage {
  const nested = json.data && !Array.isArray(json.data) ? json.data : undefined;
  const nestedData = nested?.data;
  const data = Array.isArray(json.data) ? json.data : Array.isArray(nestedData) ? nestedData : [];
  const pg = json.pagination ?? nested?.pagination;
  return {
    data,
    pagination: {
      page: pg?.page ?? page,
      limit: pg?.page_size ?? pageSize,
      total: pg?.total_items ?? data.length,
      // Lista vazia volta total_pages 0; a tela sempre tem ao menos a página 1.
      totalPages: Math.max(1, pg?.total_pages ?? 1),
    },
    summary: json.summary ?? undefined,
  };
}

/**
 * Ids devolvidos pelo lookup por número. `purchase_order_ids` traz todos os pedidos com aquele
 * número (normalmente um); `purchase_order_id` sozinho é o formato antigo da API.
 */
export function readLookupIds(
  data: { purchase_order_id?: number; purchase_order_ids?: number[] } | null | undefined,
): number[] {
  if (data?.purchase_order_ids?.length) return data.purchase_order_ids;
  return data?.purchase_order_id ? [data.purchase_order_id] : [];
}
